var _linearGradient, _path, _path2, _path3, _linearGradient2, _circle, _linearGradient3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVivaldy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sQuHWIJj4ILlbCRFFb9HVa",
    x1: 16.285,
    x2: 34.77,
    y1: 2.804,
    y2: 53.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sQuHWIJj4ILlbCRFFb9HVa)",
    d: "M30.261,42H17.739C9.84,42,6,38.16,6,30.261V17.739C6,9.84,9.84,6,17.739,6h12.522 C38.16,6,42,9.84,42,17.739v11.739C42,38.021,38.27,42,30.261,42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10.5c7.456,0,13.5,6.044,13.5,13.5S31.456,37.5,24,37.5S10.5,31.456,10.5,24S16.544,10.5,24,10.5 M24,9.5 C16.005,9.5,9.5,16.005,9.5,24S16.005,38.5,24,38.5S38.5,31.995,38.5,24S31.995,9.5,24,9.5L24,9.5z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10.5c7.456,0,13.5,6.044,13.5,13.5S31.456,37.5,24,37.5S10.5,31.456,10.5,24S16.544,10.5,24,10.5 M24,10 c-7.72,0-14,6.28-14,14s6.28,14,14,14s14-6.28,14-14S31.72,10,24,10L24,10z",
    opacity: 0.07
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sQuHWIJj4ILlbCRFFb9HVb",
    x1: 13.353,
    x2: 42.114,
    y1: 13.353,
    y2: 42.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#d9dcdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c8cc"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 13.5,
    fill: "url(#sQuHWIJj4ILlbCRFFb9HVb)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sQuHWIJj4ILlbCRFFb9HVc",
    x1: 17.687,
    x2: 36.011,
    y1: 2.192,
    y2: 52.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sQuHWIJj4ILlbCRFFb9HVc)",
    d: "M32.674,20.716c-2.223,3.853-4.446,7.706-6.669,11.567c-0.411,0.72-1.013,1.147-1.835,1.21 c-0.918,0.063-1.646-0.324-2.112-1.116c-1.408-2.413-2.801-4.842-4.193-7.263c-0.847-1.472-1.701-2.943-2.548-4.423 c-0.854-1.487,0.111-3.299,1.82-3.386c0.902-0.047,1.598,0.372,2.057,1.155c0.625,1.068,1.242,2.152,1.867,3.228 c0.451,0.775,0.886,1.559,1.345,2.318c0.665,1.116,1.646,1.741,2.951,1.82c1.843,0.111,3.56-1.226,3.782-3.18 c0.016-0.142,0.024-0.293,0.032-0.364c-0.008-0.633-0.127-1.171-0.38-1.669c-0.688-1.377,0.047-2.919,1.543-3.252 c1.218-0.269,2.484,0.625,2.642,1.859C33.054,19.751,32.943,20.249,32.674,20.716L32.674,20.716z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivaldy);
export default __webpack_public_path__ + "static/media/vivaldy.acaaa01fcac75f5b9e9bce1a9bee80d7.svg";
export { ForwardRef as ReactComponent };